// extracted by mini-css-extract-plugin
module.exports = {"text-smaller":"12px","text-regular":"14px","mapView":"MapView-module--mapView--a6cbd3"};